export function updateUserStore(data) {
  return {
    type: '@user/UPDATE',
    payload: data,
  }
}
